import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
`;

const wave = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 16px;
  width: 100%;
  min-height: 600px;
`;

export const SpinnerWrapper = styled.div`
  margin-bottom: 16px;

  svg {
    animation: ${rotate} 1s linear infinite;
  }
`;

export const IconWrapper = styled.div`
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 300;
  margin: 0 0 8px 0;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingDots = styled.span`
  display: inline-flex;
  margin-left: 2px;

  span {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
    display: inline-block;
    animation: ${wave} 1.4s ease-in-out infinite;

    &:nth-child(1) {
      animation-delay: 0s;
    }

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 24px 0;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  text-align: center;
  max-width: 420px;
`;

export const DotsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
`;

export const Dot = styled.span<{ $delay: number }>`
  width: 10px;
  height: 10px;
  background: #1a4d4d;
  border-radius: 50%;
  animation: ${bounce} 1.4s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`;

/* Mały loader w lewym górnym rogu treści, jak na /analytics. */
export const InlineLoader = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
